let workers = [];
import { Axios } from "@/services/_axios";
const requestQueue = new Map();
async function getWasm() {
  const hostname =
    window.location.host == "localhost:8080" ? "http://localhost:8080" : "";
  const url = `${hostname}/workers/mupdf/mupdf-wasm.wasm`;

  const response = await Axios.get(url, {
    responseType: "arraybuffer",
  });
  const data = response.data;
  return data;
}

let lastPrm = null;
function initWorkers(num = 5) {
  //get wasm first
  if (lastPrm) return lastPrm;
  lastPrm = new Promise(async (res, rej) => {
    workers.forEach((w) => {
      w.worker.terminate();
    });
    workers = [];
    const wasm = await getWasm();
    for (let i = 0; i < num; i++) {
      const worker = new Worker("./workers/mupdf/worker.js", {
        type: "module",
      });
      worker.onmessage = (e) => {
        const dataview = new DataView(e.data);
        const reqId = dataview.getInt32(0, true);
        const mode = dataview.getInt32(4, true);
        if (mode == 1) {
          //img
          const owidth = dataview.getInt32(8, true);
          const oheight = dataview.getInt32(12, true);
          const w = dataview.getInt32(16, true);
          const h = dataview.getInt32(20, true);
          const data = e.data.slice(24);
          const res = requestQueue.get(reqId);
          res({ w, h, owidth, oheight, data: new Uint8Array(data) });
        } else {
          //clear mode done
          const res = requestQueue.get(reqId);
          res();
        }
      };

      await sendWorkerInit(worker, wasm);
      workers.push({ worker, bookid: null });
    }
    lastPrm = null;
  });
  return lastPrm;
}

if (
  (globalThis.SERVER_MODE == "online" || location.href.includes("http")) &&
  !globalThis.ELECTRON_ENV
)
  initWorkers(5);
function sendWorkerImageJob(bookid, page, dpi) {
  page = page - 1;
  let bookWorker = workers.find((a) => a.bookid == bookid);
  if (!bookWorker) bookWorker = workers.find((a) => a.bookid == null);

  return new Promise(async (res, rej) => {
    const id = Math.floor(Math.random() * 100000);
    requestQueue.set(id, res);

    if (!bookWorker) {
      await initWorkers(5);
      bookWorker = workers[0];
      // if (bookWorker.bookid) {
      //   // await closeWorkerBook(bookWorker.bookid);
      //   // await new Promise((r) => setTimeout(r, 30))
      // }

      // bookWorker = workers.find((a) => a.bookid == null);
      // if (!bookWorker) await new Promise((r) => setTimeout(r, 30));
    }
    bookWorker.bookid = bookid;
    bookWorker.worker.postMessage({
      action: "getPage",
      page,
      dpi,
      bookid,
      requestId: id,
    });
  });
}
function sendWorkerInit(worker, wasmBuffer) {
  return new Promise((res, rej) => {
    const id = Math.floor(Math.random() * 100000);
    requestQueue.set(id, res);
    worker.postMessage({ action: "init", requestId: id, wasmBuffer });
  });
}
function closeWorkerBook(bookid) {
  return new Promise((res, rej) => {
    let bookWorker = workers.find((a) => a.bookid == bookid);
    if (!bookWorker) return res();

    const done = () => {
      //set worker to free
      bookWorker.bookid = null;
      //done
      res();
    };
    const id = Math.floor(Math.random() * 100000);
    requestQueue.set(id, done);
    bookWorker.worker.postMessage({ action: "closeBook", requestId: id });
  });
}
globalThis.__v8_wasm_ofs = { fclose: closeWorkerBook };
async function getPdfPage(
  bookId,
  page,
  dpi,
  pdfMode,
  PDFType = "21",
  imageBuffer = null
) {
  if (PDFType == "21") {
    const data = await sendWorkerImageJob(bookId, page, dpi, PDFType);
    return data;
  }

  let doc = null;
  let mupdf = pull[inx]; // pull.find((a) => a.busy == false);
  inx++;
  // while (!mupdf) {
  //   await new Promise((resolve) => setTimeout(resolve, 50));
  //   mupdf = pull.find((a) => a.busy == false);
  // }

  mupdf.busy = true;
  console.log("mupdf id is " + mupdf.id);
  if (typeof mupdf.app.then == "function") mupdf.app = await mupdf.app;

  if (PDFType == "19") page = 1;
  let bookData = PDFType == "19" ? new Uint8Array(imageBuffer) : String(bookId);
  doc = await mupdf.app.load(bookData, PDFType);

  let png = null;

  switch (pdfMode) {
    case 1:
      const id = Math.random(1 % 1000000);
      console.time("a" + id);
      png = await mupdf.app.getPxs(doc, page, dpi);
      console.timeEnd("a" + id);
      break;
    case 2:
      png = await mupdf.app.getPngRaw(doc, page, dpi);
      break;
    case 3:
      png = await mupdf.app.drawPageAsPNG(doc, page, dpi);
      break;
    default:
      png = await mupdf.app.getPxs(doc, page, dpi);
  }
  mupdf.busy = false;
  return png;
}

export default { getPdfPage };
